import firebase from '../../../config/firebase';

const database = firebase.database();

export function getSeason(callback) {
  database.ref('season').once('value').then((snapshot) => {
    const season = snapshot.val();
    callback(true, season, null);
  });
}

/**
 * Create new season
 */
export function createNewSeason (data, callback) {
  var newId = database.ref().child('season').push().key;
  data["id"] = newId;

  database.ref('season/' + newId).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

/**
 * Edit Season
 */
export function editSeason (id, data, callback) {
  database.ref('season/' + id).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

/**
 * Delete season
 */
export function deleteSeason(id, callback) {
  database.ref('season').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}
